// import api from "..";
// import { playListPassword, playListUsername } from "../../../state";
// import { convertItemsToTilesMovies, chunkArraySeries } from "../formatters/ItemFormatter";

// const cache = new Map<string, Promise<any>>();
// const leftoverTiles = new Map<string, any[]>();

// export default function (filter: string, category_id: number) {
//   return async (pageIndex: number): Promise<any> => {
//     const username = playListUsername();
//     const password = playListPassword();
//     const cacheKey = `${username}_vod_${category_id}`;
//     const tileKey = `${filter}_vod_${category_id}`;

//     const apiUrl = `/player_api.php?username=${username}&password=${password}&action=get_vod_streams&category_id=${category_id}`;

//     // Check cache first
//     if (cache.has(cacheKey)) {
//       console.log(`💾 Using cached data for VOD streams category: ${category_id}`);
//       return cache.get(cacheKey);
//     }

//     console.log(`📞 Making VOD streams API call for category ${category_id} with URL: ${apiUrl}`);

//     // Make the API call with FIXED error handling
//     const result = api
//       ._get(apiUrl)
//       .then(series => {
//         console.log(
//           `✅ VOD streams API call successful for category ${category_id}, processing ${series?.length || 0} movies/shows`,
//         );

//         // CRITICAL FIX: Ensure series is always an array
//         let results = [];

//         if (Array.isArray(series)) {
//           results = series;
//         } else if (series && typeof series === "object") {
//           // Handle different response structures
//           if (Array.isArray(series.data)) {
//             results = series.data;
//           } else if (Array.isArray(series.streams)) {
//             results = series.streams;
//           } else if (Array.isArray(series.movies)) {
//             results = series.movies;
//           } else if (Array.isArray(series.results)) {
//             results = series.results;
//           } else {
//             console.warn(
//               `Unexpected VOD streams response structure for category ${category_id}:`,
//               typeof series,
//               series,
//             );
//             results = [];
//           }
//         } else {
//           console.warn(
//             `VOD streams response for category ${category_id} is not an object or array:`,
//             typeof series,
//             series,
//           );
//           results = [];
//         }

//         console.log(
//           `📊 Processed VOD streams for category ${category_id}: ${results.length} valid items found`,
//         );

//         const existingTiles = leftoverTiles.get(tileKey) || [];

//         // FIXED: Now safe to pass to convertItemsToTilesMovies since results is guaranteed to be an array
//         const tiles = existingTiles.concat(convertItemsToTilesMovies(results));

//         const chunks = chunkArraySeries(tiles);
//         if (chunks[chunks?.length - 1]?.length < 7) {
//           leftoverTiles.set(tileKey, chunks.pop() || []);
//         } else {
//           leftoverTiles.delete(tileKey);
//         }

//         console.log(
//           `🎬 VOD streams processed for category ${category_id}: ${tiles.length} total tiles created`,
//         );
//         return tiles;
//       })
//       .catch(error => {
//         console.error(`❌ VOD streams API call failed for category ${category_id}:`, error);
//         cache.delete(cacheKey);
//         // Return empty array instead of throwing to prevent app crash
//         return [];
//       });

//     cache.set(cacheKey, result);
//     return result;
//   };
// }

// FIXED moviesProvider.js - Prevents "Unexpected token < in JSON at position 0" errors

import api from "..";
import { playListPassword, playListUsername } from "../../../state";
import {
  convertItemsToTilesMovies,
  chunkArraySeries,
} from "../formatters/ItemFormatter";

const cache = new Map<string, Promise<any>>();
const leftoverTiles = new Map<string, any[]>();

// Enhanced API call wrapper that handles JSON parsing errors
const safeApiGet = async (url) => {
  const MAX_RETRIES = 2;
  const RETRY_DELAY = 1000;

  for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
    try {
      console.log(`📡 API attempt ${attempt}/${MAX_RETRIES}: ${url}`);

      // Use the existing api._get but with enhanced error handling
      const response = await api._get(url);

      // Validate response is not HTML (common when API returns 404 page)
      if (typeof response === "string" && response.trim().startsWith("<")) {
        throw new Error(
          `Received HTML instead of JSON - likely 404 or server error`
        );
      }

      // Success case
      console.log(`✅ API call successful: ${url}`);
      return response;
    } catch (error) {
      console.warn(
        `⚠️ API attempt ${attempt} failed for ${url}:`,
        error.message
      );

      // Handle specific JSON parsing errors
      if (
        error.message.includes("Unexpected token <") ||
        error.message.includes("JSON") ||
        error.message.includes("HTML instead of JSON")
      ) {
        console.error(
          `❌ JSON parsing error for ${url} - server returned HTML instead of JSON`
        );
      }

      // If this is the last attempt, return empty array instead of throwing
      if (attempt === MAX_RETRIES) {
        console.error(
          `❌ All ${MAX_RETRIES} attempts failed for ${url}, returning empty array`
        );
        return []; // Return empty array to prevent app crash
      }

      // Wait before retry
      await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY));
    }
  }

  return []; // Fallback
};

export default function (filter: string, category_id: number) {
  return async (pageIndex: number): Promise<any> => {
    const username = playListUsername();
    const password = playListPassword();
    const cacheKey = `${username}_vod_${category_id}`;
    const tileKey = `${filter}_vod_${category_id}`;

    const apiUrl = `/player_api.php?username=${username}&password=${password}&action=get_vod_streams&category_id=${category_id}`;

    console.log("#####################", apiUrl);

    // Check cache first
    if (cache.has(cacheKey)) {
      console.log(
        `💾 Using cached data for VOD streams category: ${category_id}`
      );
      return cache.get(cacheKey);
    }

    console.log(
      `📞 Making VOD streams API call for category ${category_id} with URL: ${apiUrl}`
    );

    // FIXED: Use the safe API call wrapper
    const result = safeApiGet(apiUrl)
      .then((series) => {
        console.log(
          `✅ VOD streams API call successful for category ${category_id}, processing ${series?.length || 0} movies/shows`
        );

        // CRITICAL FIX: Ensure series is always an array
        let results = [];

        if (Array.isArray(series)) {
          results = series;
        } else if (series && typeof series === "object") {
          // Handle different response structures
          if (Array.isArray(series.data)) {
            results = series.data;
          } else if (Array.isArray(series.streams)) {
            results = series.streams;
          } else if (Array.isArray(series.movies)) {
            results = series.movies;
          } else if (Array.isArray(series.results)) {
            results = series.results;
          } else {
            console.warn(
              `Unexpected VOD streams response structure for category ${category_id}:`,
              typeof series,
              series
            );
            results = [];
          }
        } else {
          console.warn(
            `VOD streams response for category ${category_id} is not an object or array:`,
            typeof series,
            series
          );
          results = [];
        }

        console.log(
          `📊 Processed VOD streams for category ${category_id}: ${results.length} valid items found`
        );

        const existingTiles = leftoverTiles.get(tileKey) || [];

        // FIXED: Now safe to pass to convertItemsToTilesMovies since results is guaranteed to be an array
        const tiles = existingTiles.concat(convertItemsToTilesMovies(results));

        const chunks = chunkArraySeries(tiles);
        if (chunks[chunks?.length - 1]?.length < 7) {
          leftoverTiles.set(tileKey, chunks.pop() || []);
        } else {
          leftoverTiles.delete(tileKey);
        }

        console.log(
          `🎬 VOD streams processed for category ${category_id}: ${tiles.length} total tiles created`
        );
        return tiles;
      })
      .catch((error) => {
        console.error(
          `❌ VOD streams API call failed for category ${category_id}:`,
          error
        );
        cache.delete(cacheKey);

        // ENHANCED ERROR HANDLING: Handle specific error types
        if (
          error.message.includes("Unexpected token <") ||
          error.message.includes("JSON")
        ) {
          console.error(
            `🚨 JSON parsing error for category ${category_id} - API returned HTML instead of JSON`
          );
        }

        // Return empty array instead of throwing to prevent app crash
        return [];
      });

    cache.set(cacheKey, result);
    return result;
  };
}

// ADDITIONAL FIX: Enhanced API base configuration
// Add this to your api/index.js file or wherever you configure the api object:

// If you have access to the api configuration, add this interceptor:
/*
// Enhanced response interceptor for API
if (api.interceptors && api.interceptors.response) {
  api.interceptors.response.use(
    (response) => {
      // Check if response is HTML instead of JSON
      if (typeof response.data === 'string' && response.data.trim().startsWith('<')) {
        console.error('API returned HTML instead of JSON:', response.config.url);
        throw new Error('Server returned HTML instead of JSON - likely a 404 or server error');
      }
      return response;
    },
    (error) => {
      // Handle JSON parsing errors specifically
      if (error.message.includes('Unexpected token <')) {
        console.error('JSON parsing error - server returned HTML:', error.config?.url);
        return Promise.resolve({ data: [] }); // Return empty array instead of rejecting
      }
      
      // Handle 404 errors
      if (error.response?.status === 404) {
        console.warn('API endpoint not found (404):', error.config?.url);
        return Promise.resolve({ data: [] }); // Return empty array for 404s
      }
      
      return Promise.reject(error);
    }
  );
}
*/

// GLOBAL ERROR HANDLER: Add this to your main app file (index.tsx)
window.addEventListener("unhandledrejection", (event) => {
  const error = event.reason;

  // Handle JSON parsing errors from movies API
  if (
    error?.message?.includes("Unexpected token <") &&
    error?.message?.includes("JSON")
  ) {
    console.warn(
      "🛡️ Prevented JSON parsing error from movies API - server returned HTML instead of JSON"
    );

    // Log additional context
    if (error.config?.url) {
      console.warn("Failed URL:", error.config.url);
    }

    // Prevent error from reaching Sentry
    event.preventDefault();
    return;
  }

  // Handle 404 errors that cause JSON parsing issues
  if (error?.response?.status === 404 && error?.message?.includes("JSON")) {
    console.warn("🛡️ Prevented 404 JSON parsing error from movies API");
    event.preventDefault();
    return;
  }
});

// VALIDATION HELPER: Add this helper function to validate API responses
export const validateApiResponse = (response, categoryId = "unknown") => {
  try {
    // Check if response is a string that looks like HTML
    if (typeof response === "string") {
      const trimmed = response.trim();
      if (trimmed.startsWith("<") || trimmed.includes("<!DOCTYPE")) {
        console.error(
          `API returned HTML instead of JSON for category ${categoryId}`
        );
        return [];
      }
    }

    // Check if response is null or undefined
    if (response == null) {
      console.warn(`API returned null/undefined for category ${categoryId}`);
      return [];
    }

    // Ensure response is an array or can be converted to one
    if (Array.isArray(response)) {
      return response;
    }

    // Try to extract array from object response
    if (typeof response === "object") {
      if (Array.isArray(response.data)) return response.data;
      if (Array.isArray(response.streams)) return response.streams;
      if (Array.isArray(response.movies)) return response.movies;
      if (Array.isArray(response.results)) return response.results;
    }

    console.warn(
      `Unexpected response format for category ${categoryId}:`,
      typeof response
    );
    return [];
  } catch (error) {
    console.error(
      `Error validating API response for category ${categoryId}:`,
      error
    );
    return [];
  }
};

// USAGE EXAMPLE: Use validateApiResponse in your providers
/*
// In your API call .then() handler:
.then(response => {
  const validatedData = validateApiResponse(response, category_id);
  console.log(`✅ Validated ${validatedData.length} items for category ${category_id}`);
  // Continue with processing...
});
*/
